import * as React from 'react';

import { UitkCardMedia } from 'uitk-react-cards';

import { FavoriteButton } from 'components/common/shortlist/favorite-button';
import { QueuedImage } from 'components/common/media/queued-image';
import { RenderImageProps } from './title';
import { TitleBadge } from './title-badge';

interface TitleImageProps {
  src?: string;
  renderImg: RenderImageProps;
  serverRender: boolean;
  loaded?: boolean;
}

export const serverRenderImageFallbackcb = (fallback: string, style: any) => {
  const hasBackgroundSrc = style && style.backgroundImage;
  const fallbackStyle = `url(${fallback})`;

  if (!hasBackgroundSrc && fallback) {
    return { backgroundImage: fallbackStyle };
  } else if (hasBackgroundSrc && fallback && style.backgroundImage !== fallbackStyle) {
    return { backgroundImage: style.backgroundImage + `, ${fallbackStyle}` };
  }

  return style;
};

export const TitleImage: React.FunctionComponent<TitleImageProps> = ({ src, renderImg, serverRender, loaded }) => {
  const {
    fallbackImageSrc,
    name,
    propertyListingBadgeModel,
    travelAd,
    ratio,
    referralObject,
    shortlistModel,
    favButtonText,
    displaySecondaryBadge,
    queuedImageFallbackcb
  } = renderImg;

  const primary = propertyListingBadgeModel && propertyListingBadgeModel.primary;
  const id = primary && primary.text === 'Sponsored' ? 'favorite-sponsored' : 'favorite';
  const meta = shortlistModel && shortlistModel.meta;
  const hotelId = meta && meta.hotelId;

  const imageSrc = typeof src === 'undefined' ? '' : src || fallbackImageSrc;
  const queuedImageFallbackCallback = imageSrc ? (queuedImage: object) => queuedImageFallbackcb(fallbackImageSrc, queuedImage) : null;
  const serverRenderImageFallbackStylecb = imageSrc ? (style: object) => serverRenderImageFallbackcb(fallbackImageSrc, style) : null;

  return (
    <UitkCardMedia className="title__media-container">
      <QueuedImage
        src={imageSrc}
        alt={name}
        useBackgroundImage={true}
        className={`scrim-container title__media image-loader${serverRender ? '' : ' image-loader--lazy'}`}
        groupId="HSR"
        queuedImageFallbackCallback={queuedImageFallbackCallback}
        ratio={ratio}
        serverRenderCallback={serverRenderImageFallbackStylecb}
        serverRender={serverRender}
        loaded={loaded}
      >
        <TitleBadge
          propertyListingBadgeModel={propertyListingBadgeModel}
          travelAd={travelAd}
          displaySecondaryBadge={displaySecondaryBadge}
        />
        {hotelId && (
          <FavoriteButton
            key={hotelId}
            shortlistModel={shortlistModel}
            category="hotel"
            labelSave={favButtonText.labelSave}
            labelRemove={favButtonText.labelRemove}
            onSaveMessage={favButtonText.onSaveMessage}
            id={`${id}-${hotelId}`}
            referralObject={referralObject}
          />
        )}
      </QueuedImage>
    </UitkCardMedia>
  );
};
